import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import eyeIcon from "../../assests/eyeIcon.svg";
import search from "../../assests/search.svg";
import leftArrow from "../../assests/leftArrow.svg";
import filter from "../../assests/filterIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import "./UsersRoleList.css";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import emotions7 from "../../assests/emotions7.svg";
import LoadingSpinner from "../Loading/component";

export const UsersroleList = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();

  const addUser = () => navigate("/home/couponcreate");
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);
  const arrowClick = () => navigate("/");

  return (
    <div className="users-roles-container">
      <Sidebar />
      {props.loading ? (
          <LoadingSpinner />
        ) : (
      <div className="users-roles-content">
       
       
       
           {props.error && (
            <div className="error-message-top">
              {props.error}
              <button 
                className="error-close-btn"
                onClick={() => props.onDismissError()}
              >
                &times;
              </button>
            </div>
          )}
            <div className="users-roles-header">
              <button onClick={arrowClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>Coupons</h1>
            </div>

            <div className="users-roles-controls">
              <div className="user-roles-search-container">
                <input
                  type="search"
                  placeholder="Search by Coupon Code/ Coupon Id"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                 onChange={e => props?.setQuery(e.target.value)}
                />
                <img
                  src={search}
                  alt="Search"
                  className={`user-roles-search-icon ${isFocused ? "hidden" : ""}`}
                />
              </div>
              
              <Button
                onClick={addUser}
                className="add-button"
                variant="primary"
              >
                + Create Coupon
              </Button>
            </div>

            <div className="table-wrapper" ref={props.tableContainerRef}>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Coupon Code</th>
                    <th>Coupon ID</th>
                  
<th className="filter-columnstatus" style={{padding: "0",display:"flex",
    justifyContent: "center",    marginTop:"18px"}}>
  Status
  <Dropdown>
    <Dropdown.Toggle variant="link" className="filter-toggle-1">
       <div style={{display:"flex"}}><h1 style={{fontSize:"16px"}}>({props?.statusFilter})</h1><img src={filter} alt="Filter" /></div> 
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item onClick={() => props?.setStatusFilter('Activated')}>
        Activated
      </Dropdown.Item>
      <Dropdown.Item onClick={() => props?.setStatusFilter('Deactivated')}>
        Deactivated
      </Dropdown.Item>
      <Dropdown.Item onClick={() => props?.setStatusFilter("All")}>
        All
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
</th>


                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                
                  {props.filtered?.length > 0 ? (
                    props.filtered.map((item, index) => (
                      <tr key={item.id} className="user-role-view">
                       { console.log("coupon list".item)}
                        <td>{index + 1}</td>
                        <td>{item.couponName}</td>
                        <td>{item.couponId}</td>
                    
                    
                        <td>
                          <span className={`users-roles-status-badge ${item.status !== "Activated" ? "deleted" : ""}`}>
                            {item.status === "Activated" ? "Activated" : "Deactivated"}
                          </span>
                        </td>
                        <td>
                          <Link to={`/home/coupon/${item.couponId}`}>
                            <img src={eyeIcon} alt="View" className="user-role-eye-icon" />
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">
                        <div className="no-user-results">
                <img src={emotions7} alt="No users found" />
                <p>{props.error ? "Error loading users" : "No User Found"}</p>
              </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
       
       
      </div>
       )}
    </div>
  );
};